import { setSpinProps } from '@/utils/utils';
import {
  queryBuildingList,
  queryRoomList,
  getBuildingInfo,
  deleteBedroom,
} from '../services/services';

const initState = () => {
  return {
    /**
     * 寝室楼列表 Array<Object>
     * buildingName	string	楼名
     * buildingType	string
     * createUser	string
     * gmtCreate	number
     * gmtModify	nullnumber
     * id	number	寝室楼id
     * isDelete	number
     * modifyUser	string
     * orgId
     */
    buildinglist: [],
    buildingInfo: {},
    selectedBuildingId: '', // 选中的寝室楼id
    /**
     * 寝室列表 Array<Object>
     * bedroomId	number 	寝室id
     * bedroomName	string 寝室名称
     * buildingId	number
     * createUser	string
     * gmtCreate	null
     * gmtModify	number
     * id	number
     * isDelete	number
     * modifyUser	string
     * orgId	string
     */
    list: [],
    page: 1, // 页码
    pageSize: 10,
    totalElements: 1, // 总页数
    fileList: [], // 上传列表
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
  };
};

export default {
  namespace: 'roomManagement',

  state: initState(),

  effects: {
    // 获取寝室楼列表
    *fetchBuildingList(_, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const content = yield call(queryBuildingList);

        yield setSpinProps({ put, buildinglist: content || [] });

        const [{ id = '' }] = content;

        yield put({
          type: 'fetchList',
          params: {
            buildingid: id,
            page: 1,
            pageSize: 10,
          },
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    // 获取寝室入住列表
    *fetchList({ params }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });
        const { buildingid, page, pageSize } = params;
        const content = yield call(queryRoomList, {
          ...params,
        });
        const { contentList = [], totalElements = 1 } = content;
        yield put({
          type: 'fetchBuildingInfo',
        });
        yield setSpinProps({
          put,
          list: contentList,
          selectedBuildingId: buildingid,
          page,
          pageSize,
          totalElements,
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    *fetchBuildingInfo(_, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });
        const content = yield call(getBuildingInfo);
        yield setSpinProps({
          put,
          buildingInfo: content,
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    *fetchDeleteBedroom({ params }, { call }) {
      try {
        const response = yield call(deleteBedroom, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error || '网络错误，请重试');
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
